import "../src/assets/css/jdsn.scss"
import Header from './components/Header'
import Footer from './components/Footer'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { LoginCallback, Security } from '@okta/okta-react';
import { OktaAuth } from '@okta/okta-auth-js';
import SearchPage from './pages/SearchPage'
import HomeScbmPage from './pages/scbm/HomeScbmPage'
import HomePage from './pages/HomePage'
import React, { useState } from 'react';
import ReviewPage from './pages/ReviewPage'
import Campaign from './pages/admin/CampaignPage'
import { ISSUER_OKTA, CLIENT_ID_OKTA, SCOPES_SCBM, MUI_X_LICENSE_PRO } from './utils/constEnvVariables'
import ErrorPage from './pages/admin/errorPage'
import UserProvider from './providers/userProvider'
import { SCBM_USER_TYPE, SCBM_REVIEW_TYPE_ALLOWED } from './utils/surveyLiterals'
import { ProtectedRoute } from './components/security/protectedRoute'
import Page404 from './pages/admin/Page404'
import DetailsPage from './pages/details/DetailsPage';
import HomeCMPage from './pages/cm/HomeCMPage'
import HomeEMPage from './pages/em/HomeEMPage'
import ReviewCMPage from './pages/cm/ReviewPage'
import ReviewEMPage from './pages/em/ReviewPage'
import HomeCooPage from './pages/coo/HomeCOOPage'

import HomeSTPage from "./pages/st/HomeSTPage";
import STReview from "./pages/st/STReview";
import { LicenseInfo } from '@mui/x-license-pro';

import ReviewTPSPage from './pages/tps/ReviewPage'
import ReviewCOOPage from './pages/coo/ReviewPage'
import HomeTPSPage from './pages/tps/HomeTPSPage';
import { TpsContext } from "./components/tps/TpsContext";
import SurveyLogin from "./pages/survey-login/SurveyLogin";
import STErrorPage from "./pages/survey-login/STErrorPage";
import HomeOSPage from "./pages/os/HomeOSPage";
import STAdmin from "./pages/st/STAdmin";
import SurveypartHomePage from "./pages/surveypart/HomePage";
import SurveypartReviewPage from "./pages/surveypart/Review/ReviewPage";
import SelfServiceHome from "./pages/admin/selfservice/SelfServiceHome";
import SelfServiceLandingPage from "./pages/admin/selfservice/SelfServiceLandingPage";


const oktaConfig = {
  issuer: ISSUER_OKTA,
  redirectUri: window.location.origin + "/implicit/callback",
  clientId: CLIENT_ID_OKTA,
  pkce: true,
  responseType: 'code',
  scopes: SCOPES_SCBM.split(/\s+/),
  devMode: false,
  tokenManager: {
    autoRenew: true,
  }
};

let oktaAuth = new OktaAuth(oktaConfig);

LicenseInfo.setLicenseKey(MUI_X_LICENSE_PRO);



function App() {
  const [showHeaderFooter, setShowHeaderFooter] = useState(true);

  return (<>
    <Router>
      <Security oktaAuth={oktaAuth}>
        <UserProvider>
          {showHeaderFooter && <div className="d-print-none"><Header /></div>}
          <main className='container-fluid bg-gray pt-2 pb-3' id='content'>
            <Switch>
              <Route
                path='/implicit/callback'
                component={LoginCallback}
              />
              <ProtectedRoute
                exact={true}
                component={SearchPage}
                path='/'
                validUser={SCBM_USER_TYPE.SCBM_USER_TYPE_ARR}
              />
              <ProtectedRoute
                exact={true}
                component={Campaign}
                path='/campaign'
                validUser={[SCBM_USER_TYPE.SALARY]}
                validPreviousPage={['/']}
              />
              <ProtectedRoute
                exact={true}
                component={DetailsPage}
                path='/details'
                validUser={SCBM_USER_TYPE.SCBM_USER_TYPE_ARR}
                validPreviousPage={['/']}
              />
              <ProtectedRoute
                exact={true}
                path='/selfService'
                component={SelfServiceHome}
                validUser={[SCBM_USER_TYPE.SALARY]}
              />
              <ProtectedRoute
                exact={true}
                path='/selfServiceLanding'
                component={SelfServiceLandingPage}
                validUser={[SCBM_USER_TYPE.SALARY]}
              />
              <ProtectedRoute
                exact={false}
                component={HomeScbmPage}
                path='/scbm'
                validUser=''
              />
              <ProtectedRoute
                exact={false}
                component={HomePage}
                path='/survey'
                validUser=''
              />
              <ProtectedRoute
                exact={false}
                component={HomeScbmPage}
                path='/scbm/:campaign'
                validUser=''
              />
              <ProtectedRoute
                exact={true}
                component={ReviewCMPage}
                path='/cm/review'
                validUser=''
                validPreviousPage={['/cm', '/details', '/']}
              />
              <ProtectedRoute
                exact={true}
                component={ReviewEMPage}
                path='/em/review'
                validUser=''
                validPreviousPage={['/em', '/details', '/']}
              />
              
              <ProtectedRoute
                exact={false}
                component={HomeCMPage}
                path='/cm'
                validUser=''
              />
              <ProtectedRoute
                exact={false}
                component={HomeEMPage}
                path='/em'
                validUser=''
              />
              <ProtectedRoute
                exact={true}
                component={HomeSTPage}
                path="/st"
                validUser=""
              />
              <ProtectedRoute
                exact={false}
                component={STReview}
                path="/streview"
                validUser=""
                validPreviousPage={['/st', '/','/details']}
              />
              <Route
                exact={true}
                component={()=><HomeSTPage setShowHeaderFooter={setShowHeaderFooter}/>}
                path="/stext"
              />              
              <Route
                exact={false}
                component={()=> <STReview setShowHeaderFooter={setShowHeaderFooter}/>}
                path="/streviewext"
              />
              <Route
                exact={true}
                component={()=> <HomePage setShowHeaderFooter={setShowHeaderFooter}/>}
                path='/surveyext'
              />
              <Route
                exact={true}
                component={()=> <ReviewPage setShowHeaderFooter={setShowHeaderFooter}/>}
                path='/reviewext'
              />
              <Route
                exact={true}
                component={()=> <HomeCMPage setShowHeaderFooter={setShowHeaderFooter}/>}
                path='/cmext'
              />
              <Route
                exact={true}
                component={()=> <ReviewCMPage setShowHeaderFooter={setShowHeaderFooter}/>}
                path='/cmext/review'
              />
              <ProtectedRoute
                exact={false}
                component={HomeOSPage}
                path="/os"
                validUser=""
              />
              <ProtectedRoute
                exact={false}
                component={ReviewPage}
                path='/review'
                validUser={SCBM_REVIEW_TYPE_ALLOWED}
                validPreviousPage={['/scbm', '/details', '/survey', '/review', '/']}
              />
              <ProtectedRoute
                exact={true}
                component={STAdmin}
                path='/stadmin'
                validUser=""
                validPreviousPage={['/st', '/','/details']}
              />
              <Route
                path='/surveylogin'
                component={() => <SurveyLogin setShowHeaderFooter={setShowHeaderFooter}/>}
              />
              <Route
                exact={true}
                path='/sterror'
                component={()=><STErrorPage setShowHeaderFooter={setShowHeaderFooter}/>}
              />   
              <Route
                exact={true}
                path='/error'
                component={ErrorPage}
              />
               <Route
                exact={true}
                path='/coo'
                component={HomeCooPage}
              /> 
              <Route
                exact={true}
                path='/coo/review'
                component={ReviewCOOPage}
              />
              <ProtectedRoute
                exact={true}
                path='/surveypart'
                component={SurveypartHomePage}
                validUser=""
              />
              <ProtectedRoute
                exact={true}
                path='/surveypart/review'
                component={SurveypartReviewPage}
                validUser=""
                validPreviousPage={['/surveypart', '/','/details']}
              />
              <Route
                exact={true}
                path='/surveypartext'
                component={()=> <SurveypartHomePage setShowHeaderFooter={setShowHeaderFooter}/>}
              />
              <Route
                exact={true}
                path='/surveypartext/review'
                component={()=> <SurveypartReviewPage setShowHeaderFooter={setShowHeaderFooter}/>}
              />    
              <TpsContext>
                <ProtectedRoute
                  exact={true}
                  component={ReviewTPSPage}
                  path='/tps/review'
                  validUser=''
                />
                <ProtectedRoute
                  exact={true}
                  component={HomeTPSPage}
                  path='/tps'
                  validUser=''
                />
              </TpsContext>
              <Route
                path='404'
                component={Page404}
              />
            </Switch>
          </main>
          {showHeaderFooter && <Footer />}
        </UserProvider>
      </Security>
    </Router>
  </>);
}

export default App;